var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#2B2C33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 5.53125H4.6875C4.22151 5.53125 3.84375 5.90901 3.84375 6.375V9.75C3.84375 10.216 4.22151 10.5938 4.6875 10.5938H10.3125C10.7785 10.5938 11.1562 10.216 11.1562 9.75V6.375C11.1562 5.90901 10.7785 5.53125 10.3125 5.53125Z",
    stroke: "#757575",
    strokeWidth: 0.5625,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2309 5.53097V5.00362C10.2309 4.87428 10.2023 4.74655 10.1472 4.62953C10.0921 4.51251 10.0119 4.4091 9.91222 4.32666C9.81256 4.24422 9.69593 4.1848 9.57066 4.15263C9.44538 4.12045 9.31455 4.11633 9.1875 4.14054L4.55813 4.93067C4.35709 4.96899 4.17572 5.07625 4.04531 5.23397C3.9149 5.3917 3.84361 5.58998 3.84375 5.79464V6.65597",
    stroke: "#757575",
    strokeWidth: 0.5625,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 8.625C9.3575 8.625 9.24874 8.59201 9.15624 8.5302C9.06374 8.46839 8.99164 8.38054 8.94907 8.27776C8.90649 8.17498 8.89535 8.06188 8.91706 7.95276C8.93876 7.84365 8.99234 7.74342 9.071 7.66475C9.14967 7.58609 9.2499 7.53251 9.35901 7.51081C9.46813 7.4891 9.58123 7.50024 9.68401 7.54282C9.78679 7.58539 9.87464 7.65749 9.93645 7.74999C9.99826 7.84249 10.0313 7.95125 10.0313 8.0625C10.0313 8.21168 9.97199 8.35476 9.8665 8.46025C9.76101 8.56574 9.61793 8.625 9.46875 8.625Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.d934d925f91f80d5a98dbcb6011eaf9a.svg";
export { ForwardRef as ReactComponent };